import { ElementTypeEnum } from "../elementTypeMappings";
import IfcCoveringTypeEnum from "../enums/IfcCoveringTypeEnum";
import IProduct from "../interfaces/IProduct";
import CoveringData from "../model/productData/CoveringData";



const buildProductName = ( product : IProduct ) : string => {
    
    if (product.productData.productType === ElementTypeEnum.Covering) {
        const coveringData = product.productData as CoveringData

        if (coveringData.isSkirting) {
            return "Skirting";
        }

        switch (coveringData.coveringType) {
            case IfcCoveringTypeEnum.FLOORING:
                return "Floor covering";
            case IfcCoveringTypeEnum.CLADDING:
                return "Wall cladding";     
            case IfcCoveringTypeEnum.CEILING:
                return "Ceiling covering";
            default:
                return `${coveringData.coveringType}`;
        }
    }

    if (product.name)
        return product.name;

    return `${product.productData.productType} (${product.globalId})`;

};

export { buildProductName };